// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
type AskV2FeedTab = "feed" | "chats";

export function AskV2ProjectTabs({
  active,
  feedLabel,
  chatsLabel,
  viewsLabel,
  onChange,
  "data-testid": dataTestId = "ask-v2-project-tabs",
}: {
  active: AskV2FeedTab;
  feedLabel: string;
  chatsLabel: string;
  viewsLabel: string;
  onChange: (tab: AskV2FeedTab) => void;
  "data-testid"?: string;
}) {
  return (
    <div
      role="tablist"
      aria-label={viewsLabel}
      data-testid={dataTestId}
      className="flex shrink-0 gap-8 border-b border-puntt-neutral-gray-5 bg-base-white px-5"
    >
      <TabButton
        label={feedLabel}
        data-testid="ask-v2-project-feed-tab"
        active={active === "feed"}
        onClick={() => onChange("feed")}
      />
      <TabButton
        label={chatsLabel}
        data-testid="ask-v2-project-chats-tab"
        active={active === "chats"}
        onClick={() => onChange("chats")}
      />
    </div>
  );
}

function TabButton({
  label,
  active,
  onClick,
  "data-testid": testId,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
  "data-testid": string;
}) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      data-testid={testId}
      data-active={active ? "true" : "false"}
      onClick={onClick}
      className={`-mb-px border-b-[3px] bg-transparent px-0.5 py-3 text-[13px] transition-colors hover:bg-transparent ${
        active
          ? "border-puntt-accent-9 font-semibold text-puntt-accent-9"
          : "border-transparent font-normal text-puntt-neutral-gray-10 hover:text-puntt-neutral-gray-11"
      }`}
    >
      {label}
    </button>
  );
}
